export default function HeroSearch({ color, error, adornment, ...inputProps }) {
  return (
    <div className='inputContainer'>
      <input type='text' {...inputProps} />
      {adornment}

      <style jsx>{`
        .inputContainer {
          position: relative;
          height: 6.8rem;
          border-radius: 3.4rem;

          input {
            width: 100%;
            height: 100%;
            padding: 0 8rem;
            border: 0.2rem solid transparent;
            border-radius: inherit;
            outline: none;
            background: transparent;
            font-size: 2.4rem;
            transition: border-color 0.2s;
            text-align: center;

            ::-webkit-input-placeholder {
              text-align: center;
            }
            :-moz-placeholder {
              /* Firefox 18- */
              text-align: center;
            }
            ::-moz-placeholder {
              /* Firefox 19+ */
              text-align: center;
            }
            :-ms-input-placeholder {
              text-align: center;
            }

            &:focus {
              border-color: var(--primary-color);
            }

            &::placeholder {
              color: var(--secondary-text-color);
            }
          }

          :global(svg) {
            width: 3.1rem;
            height: 3.1rem;
            position: absolute;
            top: 50%;
            right: 2.4rem;
            transform: translate(0, -50%);
            fill: var(--secondary-text-color);
            pointer-events: none;
          }
        }

        @media (max-width: 1024px) {
          .inputContainer {
            height: 3.5rem;
            border-radius: 1.8rem;

            input {
              padding: 0 2.5rem;
              font-size: 1.4rem;
            }

            :global(svg) {
              width: 1.5rem;
              height: 1.5rem;
              right: 1.5rem;
            }
          }
        }
      `}</style>

      <style jsx>{`
        .inputContainer {
          background: ${color === 'secondary'
            ? 'var(--secondary-input-bg)'
            : 'var(--primary-input-bg)'};

          input {
            border-color: ${error ? 'var(--alert-color)' : 'transparent'};
          }
        }
      `}</style>
    </div>
  )
}
